import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import App from "./App.vue";
import "./registerServiceWorker";
// @ts-ignore
import VueMatomo from "vue-matomo";
// @ts-ignore
import getMatomoConfig from "../matomo.config";
import "./assets/styles/index.css";
import router from "@/router";
import store from "@/store";
// @ts-ignore
import { Auth0Plugin } from "./auth0-plugin";

Vue.config.productionTip = false;

async function awaitStageConfig() {
  if (!store.state.stageConfig.stage) {
    await store.dispatch("stageConfig/fetchStageConfig");
  }
  const { auth0Domain, auth0ClientId, auth0Audience, auth0RedirectUri } =
    store.state.stageConfig;
  const AUTH0_SCOPES = "openid profile email address phone";
  Vue.use(Auth0Plugin, {
    domain: auth0Domain,
    clientId: auth0ClientId,
    redirectUri: auth0RedirectUri,
    audience: auth0Audience,
    scope: AUTH0_SCOPES,
    onRedirectCallback: (appState: any) => {
      router.push(
        appState && appState.targetPath
          ? appState.targetPath
          : window.location.pathname
      );
    }
  });
}

(async () => {
  await awaitStageConfig();
  if (store.state.stageConfig.features.enableMatomoTracking) {
    Vue.use(VueMatomo, getMatomoConfig(router));
  }
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
})();
